const MIN_STEP = 1;
export const ONBOARDING_STEP_COUNT = 4;
const MAX_STEP = ONBOARDING_STEP_COUNT;

function clampStep(step: number): number {
  if (!Number.isInteger(step)) return MIN_STEP;
  return Math.max(MIN_STEP, Math.min(MAX_STEP, step));
}

/** A saved journey may revisit an earlier screen, but it may not skip ahead by
 * changing the step in the URL. Legacy 5–8 progress safely lands on Step 4. */
export function getAllowedOnboardingStep(requestedStep: number | null, savedStep: number): number {
  const allowedThrough = clampStep(savedStep);
  if (requestedStep === null) return allowedThrough;
  return Math.min(clampStep(requestedStep), allowedThrough);
}

/** Reopening an earlier screen changes the view, never the saved finish line. */
export function keepFarthestOnboardingStep(savedStep: number, requestedStep: number): number {
  return Math.max(clampStep(savedStep), clampStep(requestedStep));
}

/** One radio choice replaces any older multi-provider selection in Pass 1. */
export function singleOrderSourceSelection(platform: string | null): string[] {
  const selected = platform?.trim();
  return selected ? [selected] : [];
}

/** Keep the guided-onboarding marker through detours such as overhead review. */
export function productSetupPath(
  stage: "costs" | "review",
  fromGuided: boolean,
  resetReview = false,
): string {
  const params = new URLSearchParams({ stage });
  if (fromGuided) params.set("from", "guided");
  if (resetReview) params.set("resetReview", "1");
  return `/onboarding/chat?${params.toString()}`;
}
